import { render, staticRenderFns } from "./relay.vue?vue&type=template&id=781b1255&scoped=true&"
import script from "./relay.js?vue&type=script&lang=js&"
export * from "./relay.js?vue&type=script&lang=js&"
import style0 from "./relay.css?vue&type=style&index=0&id=781b1255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781b1255",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
